<div class="p-a cipo--height--full cipo--overflow--auto">
    <h3>Files Tree. Implementation example of CipoTreeComponent</h3>
    <p class="cipo-text--medium-lg">Selected node: {{ selectedNode()?.name }}</p>
    <div fxLayout>
        <div fxFlex>
            <p>My drive (no entityInstanceId provided)</p>
            <cipo-folder-tree (nodeClick)="onNodeClick($event)" [canAddFolder]="true" />
        </div>
        <div fxFlex>
            <p>Project Files (with context entityInstanceId)</p>
            <cipo-folder-tree
                (nodeClick)="onNodeClick($event)"
                [entityInstanceId]="userStore.contextEntityInstanceId()" />
        </div>
    </div>
</div>
